import { Box, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import ClaimApiService from "../../../adapters/xhr/ClaimApiService";
import { getConfirmation } from "../../../components/my-confirmation-dialog/MyConfirmationDialog";
import { MyTextField } from "../../../components/my-text-field/MyTextField";
import MyContext from "../../../contexts/MyContext";
import { TrainTheme } from "../../../infrastructure/TrainThemeProvider";
import { FormWrapper } from "../FormWrapper";
export const CommuterTicketForm1 = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const [biljettnummerValueErr, setBiljettnummerValueErr] = useState("");

  const validate = async () => {
    if (!myContext.biljettnummerValue.trim()) {
      setBiljettnummerValueErr("required");
    } else {
      setBiljettnummerValueErr("");
      var ticket = await getTicketInfoAsync();
      myContext.changeTicketInfo(ticket);
      if (ticket) {
        if (ticket.maxReimbursementOverTicketPrice) {
          const confirmed = await getConfirmation({
            title: t("info"),
            message: t("max_reimbursement_over_ticket_price"),
            theme: TrainTheme,
          });
          if (confirmed) myContext.changeActiveSlide((myContext.activeSlide += 1));
        } else myContext.changeActiveSlide((myContext.activeSlide += 1));
      } else myContext.changeActiveSlide((myContext.activeSlide += 1));
    }
  };

  const getTicketInfoAsync = async () => {
    let result = await ClaimApiService.getTicketById(myContext.biljettnummerValue.trim(), myContext.ticketType);
    if (result?.isSuccess && result?.data) return result.data;
    else return null;
  };

  return (
    <MyContext.Consumer>
      {(context) => (
        <React.Fragment>
          <FormWrapper onContinue={validate} hasBackButton={false} number={`1/5`} heading={`${t("movingo")}`}>
            <p id="required-description" className="margin bottom-0" style={{ marginTop: "0.5rem", width: "100%" }}>
              <Box component="small" color="error.main">
                *
              </Box>
              <small> {t("required_field")}</small>
            </p>
            <MyTextField
              autoComplete="on"
              required={true}
              helperText={t(biljettnummerValueErr)}
              value={context.biljettnummerValue}
              label={t("ticket_number")}
              onChange={context.changeBiljettnummerValue}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
              maxLength={100}
            />
            <Typography variant="caption" component="span" style={{ width: "100%", marginBottom: "0.5rem" }} dangerouslySetInnerHTML={{ __html: t("movingo_ticket_description.purchased_in_movingo_app") }} />
            <Typography variant="caption" component="span" style={{ width: "100%" }} dangerouslySetInnerHTML={{ __html: t("movingo_ticket_description.purchased_in_sj_app") }} />
          </FormWrapper>
        </React.Fragment>
      )}
    </MyContext.Consumer>
  );
};
